import React from 'react';
import { Link } from 'react-router-dom';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import * as ProxyHelper from "../ProxyHelper";

class AccessType extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: ''
        };
    }

    componentDidMount() {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.AcceptType.ComponentDidMount${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
    }

    isValid() {
        const { healthrecord, pharmacy } = this.props;
        this.setState({
            error: !healthrecord && !pharmacy ? 'Please select a type or types of access' : ''
        });
        return healthrecord || pharmacy;
    }    

    onAccessTypeChange = (e) => {
        if (e.target) {
            this.props.onAccessTypeChange(e);
            if (e.target.checked) {
                this.setState({
                    error: ''
                });
            }
        }
    }    

    render() {
        const { isMinor, healthrecord, pharmacy, myChartId, isDcjEnrollment, enableProxyRequestV2 } = this.props;
        const { error } = this.state;
        const disableCheckedMedical = isDcjEnrollment && healthrecord;

        return (
            <div className="request-access-type-container md-width-step" style={this.props.style}>
                <div className="row">
                    <div className="col-12 text-center">
                        <h1 className="step-heading step-heading-md">What would you like to access?</h1>
                        <p>Select all that apply</p>
                    </div>
                    <div className="col-12 step-form-container request-access-type">
                        <div className="row justify-content-center row-card-eq">
                            <div className="col-12 col-md-6 text-center">
                                <label className={`card ${healthrecord ? 'selected' : ''} ${myChartId ? "" : "medical-record-disabled-style"} ${disableCheckedMedical ? "no-pointer" : ""}`} name="healthrecord">                                    
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 card-icon">
                                                <span className={healthrecord ? 'svg-btn-medical-records' : 'svg-btn-medical-records-gray'} />
                                            </div>
                                            <div className="col-12">
                                                <div className="card-heading">Medical Records</div>
                                                {myChartId ?
                                                    <div className="card-hint"> 
                                                        {!isMinor && !enableProxyRequestV2 &&
                                                            <p className="card-note">*medical power of attorney required</p>
                                                        }
                                                        {enableProxyRequestV2 ? "book appointments, view exam results & message their doctor" :"book appts, message their doctor & more" }
                                                    </div> :
                                                    <div className="card-hint">to request access, you must first link your medical record <Link
                                                        to={{
                                                            pathname: '/linkedaccounts',
                                                            searchParams: "openMyChart=true"
                                                        }}>here</Link></div>
                                                }                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <div className="col-12">
                                            <div className="checkbox-container">
                                                <input type="checkbox" name="healthrecord" disabled={disableCheckedMedical} checked={healthrecord} onChange={(e) => this.onAccessTypeChange(e)} />
                                                <span className={myChartId ? "checkmark" : "checkmark disabled-style"} />
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <div className="col-12 col-md-6 text-center">
                                <label className={`card ${pharmacy ? 'selected' : ''}`} name="pharmacy">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 card-icon">
                                                <span className={pharmacy ? 'svg-btn-pharmacy' : 'svg-btn-pharmacy-gray'} />
                                            </div>
                                            <div className="col-12">
                                                <div className="card-heading">Baylor Scott & White Pharmacy</div>
                                                <div className="card-hint">view & refill prescriptions from a BSW pharmacy</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <div className="col-12">
                                            <div className="checkbox-container">
                                                <input type="checkbox" name="pharmacy" checked={pharmacy} onChange={(e) => this.onAccessTypeChange(e)} />
                                                <span className="checkmark" />
                                            </div>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>
                        {
                            (error && error !== "") &&
                            <div className="row">
                                <div className="col-12 validation-error-container text-center">
                                    <div className="error-msg">
                                        {error}
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}
export default AccessType;